import { useEffect, useState } from 'react';
import { Modal } from 'src/components/Modal';
import { InputSimple } from 'src/v2/commonComponents/InputSimple';
import { Button } from 'src/v2/commonComponents/Button';
import styles from './RenameFileModal.module.scss';

type RenameFileModalProps = {
  isOpen: boolean;
  defaultValue: string;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: (value: string) => void;
};

export const RenameFileModal = ({
  isOpen,
  defaultValue,
  isLoading,
  onClose,
  onSubmit,
}: RenameFileModalProps) => {
  const [newValue, setNewValue] = useState<string>(defaultValue);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    setNewValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (value: string) => {
    if (value.length === 0) {
      setError('This field is required.');
    }

    if (error.length > 0) {
      setError('');
    }

    setNewValue(value);
  };

  const handleSubmit = () => {
    const trimmedValue = newValue.trim();

    if (trimmedValue.length === 0) {
      setError('This field is required.');
      return;
    }

    onSubmit(newValue);
  };

  const isDisabledSubmit = !newValue || newValue === defaultValue || isLoading;

  return (
    <Modal open={isOpen} onClose={onClose} overlayClassName={styles.overlay}>
      <h5 className={styles.title}>Rename file</h5>

      <div className={styles.body}>
        <InputSimple onChange={handleChange} value={newValue} />

        <p>
          {error.length > 0 && <span className="nj-field-error">{error}</span>}
        </p>
      </div>

      <div className={styles.buttonsWrapper}>
        <Button onClick={handleSubmit} disabled={isDisabledSubmit}>
          Submit
        </Button>
      </div>
    </Modal>
  );
};
